var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "discuss_wrap",
      style: "height:" + _vm.height
    },
    [
      _c("div", {
        staticClass: "menu-toggle",
        class: { "menu-open": !_vm.menuFlag },
        on: { click: _vm.toggleMenu }
      }),
      _vm._v(" "),
      _vm.menuFlag
        ? _c("div", { staticClass: "discuss_left" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { active: index === _vm.tabIndex },
                    on: {
                      click: function($event) {
                        return _vm.tab(index)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      { staticClass: "list-group-item list-group-item-action" },
                      [
                        _c("i", {
                          class: item.class,
                          style:
                            "background:url(" +
                            item.src +
                            ") no-repeat;background-size:100%"
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(item.name))])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "discuss_right" },
        [
          _vm.tabIndex == 0 ? _c("alldiscuss") : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex == 1 ? _c("teacherdiscuss") : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex == 2 ? _c("studentdiscuss") : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7826c7f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7826c7f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/discussAnswer.vue
// module id = null
// module chunks = 